module.exports = __webpack_public_path__ + "media/images/hexa3-8df48e3f1145a19e141201281ac08461.png";